var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFatIcon = function SvgFatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 481419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.46667 9.1C4.20893 9.1 4 8.89107 4 8.63334C4 8.3756 4.20893 8.16667 4.46667 8.16667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.4668 9.1C4.72454 9.1 4.93347 8.89107 4.93347 8.63334C4.93347 8.3756 4.72454 8.16667 4.4668 8.16667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.53356 12.1667C7.27583 12.1667 7.06689 11.9577 7.06689 11.7C7.06689 11.4423 7.27583 11.2333 7.53356 11.2333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.5332 12.1667C7.79094 12.1667 7.99987 11.9577 7.99987 11.7C7.99987 11.4423 7.79094 11.2333 7.5332 11.2333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4 12.1667L8 8.16667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.5 10.5455C0.5 14.2955 2.96243 16 6 16C9.03753 16 11.5 14.2955 11.5 10.5455C11.5 6.79545 6 1 6 1C6 1 0.5 6.79545 0.5 10.5455Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgFatIcon;